import ID from '../../../_helpers/uuid';
import { RECEIPT_PAYMENT_TYPES, RECEIPT_CATEGORY_TYPES } from '@/contants/form';
const prepareSelectOptions = (options) => {
    return options.map((option) => {
        return {
            ...option,
            id: ID.uuid(),
        };
    });
};

export const payroll = () => {
    return {
        defaultZealEmployeeFormElements: [
            {
                data: [],
                id: ID.uuid(),
                key: 'Header',
                fieldName: 'Basic Information',
                type: 'textbox',
                instruction: '#Note: This form should be submitted by Employee only',
            },
            {
                required: true,
                data: [],
                key: 'Email',
                fieldName: 'Email',
                type: 'textbox',
                autofill: 'email',
                instruction: 'Valid email address is in the format yourname@example.com',
                specialityKey: 'email',
            },
            {
                required: true,
                data: [
                    {
                        key: 'firstName',
                        name: 'First Name',
                        type: 'text',
                        autofill: 'firstName',
                    },
                    {
                        key: 'lastName',
                        name: 'Last Name',
                        type: 'text',
                        autofill: 'lastName',
                    },
                ],
                id: ID.uuid(),
                key: 'FullName',
                fieldName: 'Full Name',
                type: 'textbox',
                instruction: '',
                specialityKey: 'fullName',
            },
            {
                required: true,
                data: [],
                id: ID.uuid(),
                key: 'DatePicker',
                fieldName: 'Date Of Birth',
                type: 'date',
                instruction: '',
                specialityKey: 'dateOfBirth',
            },
            {
                required: true,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Social Security Number',
                type: 'textbox',
                instruction: 'SSN must be a 9 digit number',
                specialityKey: 'ssn',
            },
            {
                required: true,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Address Line 1',
                type: 'textbox',
                instruction: 'Residential Street Address (e.g. 456 Park Avenue)',
                specialityKey: 'addressLine1',
            },
            {
                required: false,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Address Line 2',
                type: 'textbox',
                instruction: 'Residential Street Address Line 2 (i.e. apt numbers, suite no., etc.)',
                specialityKey: 'addressLine2',
            },
            {
                required: true,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Residential City',
                type: 'textbox',
                instruction: '(e.g. New York)',
                specialityKey: 'city',
            },
            {
                required: true,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'State',
                type: 'textbox',
                instruction: 'State should be in standard two letter short form (e.g. NY)',
                specialityKey: 'state',
            },
            {
                required: true,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Zip',
                type: 'textbox',
                instruction: 'Zip code should be a number from 5 to 9 digits',
                specialityKey: 'zip',
            },
            {
                required: true,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Phone Number',
                type: 'textbox',
                instruction: 'Phone number should be a number up to 10 digits',
                specialityKey: 'phone',
            },
            {
                required: false,
                data: [],
                id: ID.uuid(),
                key: 'Header',
                fieldName: 'Bank Account',
                type: 'textbox',
                instruction: '',
            },
            {
                required: false,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Institution Name',
                type: 'textbox',
                instruction: '',
            },
            {
                required: false,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Account Number',
                type: 'textbox',
                instruction: '',
            },
            {
                required: false,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Routing Number',
                type: 'textbox',
                instruction: '',
            },
            {
                required: false,
                data: [
                    {
                        text: 'Checking',
                        value: 'checking',
                    },
                    {
                        text: 'Savings',
                        value: 'savings',
                    },
                ],
                id: ID.uuid(),
                key: 'Select',
                fieldName: 'Account Type',
                type: 'select',
                instruction: '',
            },
        ],
        defaultPtoFormElements: [
            {
                data: [],
                fieldName: 'Accrual Policy',
                id: ID.uuid(),
                key: 'AccrualPolicySelect',
                type: 'select',
                required: true,
                specialityKey: 'accrualPolicy',
            },
            {
                fieldName: 'Datetime Range',
                id: ID.uuid(),
                key: 'DateTimeRangePicker',
                type: 'datetimerange',
                required: true,
                specialityKey: 'dateRange',
            },
            {
                fieldName: 'Signature',
                id: ID.uuid(),
                key: 'Signature',
                type: 'signature',
                required: true,
                specialityKey: 'signature',
            },
        ],
        defaultPayrollReceiptFormElements: [
            {
                type: 'textbox',
                fieldName: 'Receipt Form',
                key: 'Header',
                instruction: '#Note: This form should be submitted by Employee only, on Client Channel',
                required: false,
                data: [],
                id: ID.uuid(),
            },
            {
                required: true,
                data: [],
                key: 'DatePicker',
                fieldName: 'Date on receipt',
                type: 'date',
                id: ID.uuid(),
                specialityKey: 'dateOnReceipt',
            },
            {
                required: true,
                data: [],
                key: 'Image',
                fieldName: 'Receipt Image',
                type: 'file',
                id: ID.uuid(),
                specialityKey: 'receiptImage',
            },
            {
                required: false,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Vendor/Merchant Name',
                type: 'textbox',
                specialityKey: 'vendor',
            },

            {
                required: false,
                data: [],
                key: 'InputField',
                fieldName: 'Description',
                type: 'textbox',
                instruction: `What's it for (Activity/Product/Event/Etc.)?`,
                id: ID.uuid(),
                specialityKey: 'description',
            },
            {
                required: false,
                key: 'Select',
                fieldName: 'Payment Method',
                type: 'select',
                instruction: '',
                id: ID.uuid(),
                specialityKey: 'paymentMethod',
                data: prepareSelectOptions(RECEIPT_PAYMENT_TYPES),
            },
            {
                required: false,
                data: [],
                key: 'InputField',
                fieldName: 'Amount',
                type: 'textbox',
                instruction: 'In dollars ($). Must be a number',
                id: ID.uuid(),
                specialityKey: 'amount',
            },
            {
                required: false,
                key: 'Select',
                fieldName: 'Category',
                type: 'select',
                instruction: 'Selete a category to better organize your spend',
                id: ID.uuid(),
                specialityKey: 'category',
                data: prepareSelectOptions(RECEIPT_CATEGORY_TYPES),
            },
            {
                required: false,
                type: 'checkbox',
                key: 'Checkbox',
                fieldName: 'Receipt Classification',
                data: [
                    {
                        text: 'Reimbursable',
                        value: ID.uuid(),
                    },
                    {
                        text: 'Billable',
                        value: ID.uuid(),
                    },
                ],
                id: ID.uuid(),
                specialityKey: 'receiptClassification',
            },
            {
                required: true,
                data: [],
                key: 'Signature',
                fieldName: 'Signature',
                type: 'signature',
                id: ID.uuid(),
            },
        ],
    };
};
